import LegendItem from '../data-types/legend-item-data';

export const LEGEND_ITEMS: LegendItem[] = [
  { color: '#bbecbc', description: 'Atracados' },
  { color: '#f4fa58', description: 'Esperados' },
  { color: '#fff', description: 'Desatracados' },
  { color: '#ff9a2e', description: 'Na Barra' },
];
